<template>
    <div class="not-found">
      <div>
        <label>404 страница не найдена, нажмите чтобы перейти на главную</label>
        <router-link to="/">Home</router-link>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Page404',
  methods: {
    home() {


    }
  }
}
</script>

<style scoped>
  .not-found {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    flex-direction: column;
  }
</style>
